import { useState,useRef, useEffect} from 'react';
import { checkSmsCode, requestSmsCode } from '@/services/api';
import { Navigate } from "react-router-dom";
import RetrievePasswordRender from './children/RetrievePasswordRender';
import SliderCaptch from '../../components/SliderCaptcha';

const RetrievePassword = (props) => {
    const [submitLogin, setSubmitLogin] = useState(false);
    const [linkToSetPassword, setLinkToSetPassword] = useState(false); //是否修改密码页面
    const [verifyToken,setVerifyToken] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isShowCode, setIsShowCode] = useState(false);
    const [time, setTime] = useState(60);
    const userPhone = useRef();

    // 发送短信验证码
    const sendCode = async (phone) => {
        // setIsModalVisible(true);
        // userPhone.current = phone;
        if (isShowCode) { // 倒计时未结束,不能重复点击
            return;
        }
        const params = {
            type: 1,
            scene: 3,
            brand_id: 7,
            phone: phone,
        }
        try {
            const res = await requestSmsCode(params);
            if (res.code === 200) {
                setIsShowCode(true);
                // 倒计时
                const active = setInterval(() => {
                    setTime((preSecond) => {
                        if (preSecond <= 1) {
                            setIsShowCode(false)
                            clearInterval(active)
                            // 重置秒数
                            return 60;
                        }
                        return preSecond - 1;
                    })
                }, 1000)
            }
        } catch (error) {
            console.log(error);
        }
    }

    //滑动验证码验证成功调获取验证码接口
    // const handerSuccess = async () => {
    //     if (isShowCode) { // 倒计时未结束,不能重复点击
    //         return;
    //     }
    //     setIsShowCode(true);
    //     // 倒计时
    //     const active = setInterval(() => {
    //         setTime((preSecond) => {
    //             if (preSecond <= 1) {
    //                 setIsShowCode(false)
    //                 clearInterval(active)
    //                 // 重置秒数
    //                 return 60;
    //             }
    //             return preSecond - 1;
    //         })
    //     }, 1000)
        
    //     document.querySelector('.verify-bar .icon').classList.add('icon-success');
    //     const params = {
    //         type: 1,
    //         scene: 3,
    //         brand_id: 7,
    //         phone: userPhone.current,
    //     }
    //     const { code } = await requestSmsCode(params);
    //     if (code === 200) {
    //         setIsModalVisible(false)
    //     }
    // }

    // 校验验证码
    const requestRetrievePassword = async (params) => {
        setSubmitLogin(true)
        params = {
            ...params,
            brand_id: 7
        }
        const { code, data } = await checkSmsCode(params);
        if (code === 200 && data) {
            setVerifyToken(data.verify_token);
            setLinkToSetPassword(true);
        }
        setSubmitLogin(false)
    }

    useEffect(() => {
        document.title = "忘记密码-个人中心";
        document.querySelector('meta[name="keywords"]').setAttribute('content','忘记密码找回');
        document.querySelector('meta[name="description"]').setAttribute('content','牛学长账号忘记密码找回');
    })


    return (
        <>
            {linkToSetPassword && verifyToken && <Navigate to={`/set-password`} state={{'verify_token': verifyToken}} replace={true} />}
            <RetrievePasswordRender
                submitLogin={submitLogin}
                requestRetrievePassword={requestRetrievePassword}
                sendCode={(phone) => sendCode(phone)}
                isShowCode={isShowCode}
                time={time}
            />
            {/* <SliderCaptch
                isModalVisible={isModalVisible}
                handleCancel={() => setIsModalVisible(false)}
                handerSuccess={handerSuccess}
            /> */}
        </>
    );
}

export default RetrievePassword;
